import React from "react";
import { Input } from "antd";
import "./styles.scss";

const InputPassword = ({
  value,
  title,
  titleSize,
  subtitle,
  width,
  placeholder,
  onChange,
  type,
  onEnter,
  error,
  des,
  className,
  ...props
}) => {
  const onKeyUp = (e) => {
    if (e.code === "Enter" && onEnter) {
      onEnter();
    }
  };

  return (
    <div className="input-container " style={{ width: width || "100%" }}>
      {title && (
        <div className="input-title" style={{ fontSize: titleSize || 16 }}>
          {title}
        </div>
      )}
      {subtitle && <div className="input-subtitle">{subtitle}</div>}

      <div className="input-password">
        <Input.Password
          className={error ? `${className} error-text` : className}
          {...props}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          type={type}
          onKeyUp={onKeyUp}
        />
        {des && <div className="des-text">({des})</div>}
      </div>
      {error ? <span className="input-error-message">{error}</span> : null}
    </div>
  );
};
export default InputPassword;
